import {getUrlSearch} from '@/utils/getUrlSearch';

export interface XApp {
  isGaotuApp: boolean;
  isGongkaoApp: boolean;
  isTutuApp: boolean;
  isJingpinApp: boolean;
  isXinliApp: boolean;
  isKetangApp?: boolean;
}

export type AppName = 'gaotu' | 'gongkao' | 'tutu' | 'jingpin' | 'xinli' | 'ketang';

export type Channel = 'browser' | '';

const ua = window.navigator.userAgent.toLowerCase();
const getIsXApp = (appName: string) => ua.includes('gaotuapp-')
  && (new RegExp(`/${appName}(/noah)?$`).test(ua));

const useUa = () => {
  // app 内打开参数
  const isXApp: XApp = {
    isGaotuApp: getIsXApp('gaotu'),
    isGongkaoApp: getIsXApp('gongkao'),
    isTutuApp: getIsXApp('tutu'),
    isJingpinApp: getIsXApp('jingpin'),
    isXinliApp: getIsXApp('xinli'),
    isKetangApp: getIsXApp('ketang'),
  };
  const isApp: boolean = Object.values(isXApp).includes(true);
  const isAndroid: boolean = ua.includes('android');
  const isIOS: boolean = ua.includes('mac os x');
  const isWechat: boolean = ua.includes('micromessenger');

  const searchJson: { [key: string]: string } = getUrlSearch();
  // 端外打开参数
  const outOpenParams = {
    app: searchJson.app as AppName || 'gaotu',
    channel: searchJson.channel as Channel || '',
  };

  return {ua, isXApp, isApp, isAndroid, isIOS, isWechat, outOpenParams};
};


export default useUa;
